import {ChangeDetectionStrategy, Component, inject, Signal, viewChild} from "@angular/core";
import {Page} from "../../navigation/page";
import {NotificationService} from "../../notification/notification.service";
import {IdentityModel} from "../identity.model";
import {FormComponent} from '../../inputs/form/form.component';
import {PasswordFieldComponent} from '../../inputs/password-field/password-field.component';
import {IdentityChangePasswordService} from "../identity-change-password.service";
import {ModalPageLayoutComponent} from '../../page-layout/modal-page-layout/modal-page-layout.component';
import {FormsModule} from '@angular/forms';
import {ButtonComponent} from '../../buttons/button/button.component';
import {PageFooterControlDirective} from '../../page-layout/page-footer-control.directive';

@Component({
    selector: "woa-change-password-page",
    templateUrl: "change-password-page.component.html",
    styleUrl: "change-password-page.component.scss",
    providers: [
        IdentityChangePasswordService,
        {provide: Page, useExisting: ChangePasswordPageComponent}
    ],
    imports: [
        ButtonComponent,
        FormComponent,
        FormsModule,
        ModalPageLayoutComponent,
        PageFooterControlDirective,
        PasswordFieldComponent
    ],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class ChangePasswordPageComponent extends Page {
    private notificationService: NotificationService = inject(NotificationService);
    private identityChangePasswordService: IdentityChangePasswordService = inject(IdentityChangePasswordService);
    public identityModel: IdentityModel = inject(IdentityModel);

    public readonly form: Signal<FormComponent> = viewChild.required(FormComponent);

    oldPassword: string;
    newPassword: string;

    async changePassword(): Promise<void> {
        if (!this.form().valid) {
            return;
        }

        try {
            await this.identityChangePasswordService.performAction({
                oldPassword: this.oldPassword,
                newPassword: this.newPassword
            });
            void this.dismiss();
        } catch (error) {
            return this.notificationService.displayFooterError(error, "woa.notification.passwordChangeFailed");
        }
    }
}
